import { transformDateValue } from 'core/js/FormUtils';
export const getCtitemView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let ctitemList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Quantity","fieldValue":transformDataValue(data.quantity,"double"), "fieldType":"double"},
                            {"fieldLabel":"Unit Name","fieldValue":transformDataValue(data.unitname,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          ctitemList.push(card);
  })
  return ctitemList;
}